import React, { Component }  from 'react';
import Footer from '../components/layout/footer';
import Header from '../components/layout/header';
import AboutUs from '../components/section/about_us';
import Apply from '../components/section/apply';
import Beyond from '../components/section/beyond_academics';
import Cbse from '../components/section/cbse';
 import config from '../constant';


class ApplyMain extends Component {
    componentDidMount(){
        document.title = "Apply | " + config.SIE_NAME
      }
        render(){
    return(
        <div>
            <Header/>
            <Apply/>
             <Footer/>


        </div>
    );

}
    }
export default ApplyMain;